import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bo-toast',
  imports: [CommonModule],
  templateUrl: './success-toast.component.html',
  styleUrls: ['./success-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  @Input() title = '';
  @Input() message = '';
  @Input() icon = 'pi pi-check';
  @Input() visible = signal(false);
  @Input() duration = 2000;

  private timeoutId?: number;

  show(): void {
    this.visible.set(true);

    if (this.duration > 0) {
      this.timeoutId = window.setTimeout(() => {
        this.hide();
      }, this.duration);
    }
  }

  hide(): void {
    this.visible.set(false);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = undefined;
    }
  }

  onClose(): void {
    this.hide();
  }
}
